<template>
  <div>
 
    <section  class="navbarsection" style="margin-top: -50px;">
      <div class="txtdata">
        <h1  style="padding-top: 200px;"></h1>
      </div>
        <div class="videosection" >
          <div  v-show="pvisvideo === true && pvpictureimage === false ">
            <Transition class="transition thing">
              <video-background 
                playbackRate=0.2
                :src="src"
                :poster="poster"
                :class="`thing playercss`"
                :style="`height: 600px;`">
              </video-background>
            </Transition>
          </div>
        
            <div id="panorama"  v-show="pvisvideo === false && pvpictureimage === true"  :style="`height: 600px; padding-top: -5px;`">
            </div>
  
            <img :src="poster" style="width: 100%; height: 600px;" class="imgcss" 
            v-show="pvisvideo === false && pvpictureimage === false || pvisvideo === true && pvpictureimage === true" />
   
      </div>
      <div class="overlay"></div>
      <div style="margin-top: -200px; color: white; margin-left: 50px; margin-bottom: 300px;">
        <h1 class="" v-html="imagetext" :class="formatvhtml"></h1>
      </div>
    </section>

  <!-- <div class="allreportsformat">
    <AllReports :lastrecordsreportpresent="lastrecordsreportpresent" :reportpresentation="reportpresentation" 
    :openpdf="openpdf" :singlereporttitle="singlereporttitle" :rptfulltext="rptfulltext" 
    :rpcoverpageimagepath="rpcoverpageimagepath" :rplinkname="rplinkname" :bgimage="bgimage" 
    :showbg="showbg" :showrptfulltext="showrptfulltext"
    />
  </div> -->
  
  <!-- <div  class="recentdocsec">
    <HorizontalDatesreport :pyear="pyear" :getreportbyyears="getreportbyyears" :myPicUrl="myPicUrl" @click="getIdValue($event)"/>
  </div> -->
    <section class="goalsperfsec">
      <!-- <div class="card shadow regfilingcard">
        <div class="goalspeftitle"></div>
        <div class="row">
          <div class="col-xs-12 col-sm-12">
            <div v-html="regfilings"></div>
          </div>
        </div>
      </div> -->
      <div v-html="copymsg" class="copymsgclass">
        
      </div>
    </section>
  
  </div>
</template>

<script>

import AllReports from '@/components/AllReports.vue';
import HorizontalDatesreport from '@/components/HorizontalDatesreport.vue';
import BreadCrumbs from '@/components/BreadCrumbs.vue';
require('@/assets/css/pannellium-2.5.css');
require('@/assets/css/video-js.css');
require('@/globalDeclare.js');
import axios from 'axios';
import moment from 'moment';



export default {
  name: 'AboutView',
  components: {
  AllReports, HorizontalDatesreport, BreadCrumbs
},
data() {
  return {
  videoimage: [],
  imagetext: '',
  src: '',
  playrate: '',
  poster: '',
  // pvwebm: '',
  // pvmp4: '',
  pvstyle: '',
  pvsrc: '',
  pvisvideo: false,
  pvpanorama1: '',
  pvpanorama2: '',
  pvpanorama3: '',
  pvhotspot1: '',
  pvhotspot2: '',
  pvhotspot3: '',
  showVideo: false,
  showPanorama: false,

  myPicUrl: '',

  reportpresentation: [],
  reportcnt: '',
  lastrecordsreportpresent: [],
  rppdfpath: '',
  rptitle: '',
  rpdate: '',
  rplinkname: '',
  rptfulltext: '',
  rpcoverpageimagepath: '',
  singlereporttitle: '',
  rplinkname: '',
  rpdate: '',
  showbg: false,
  bgimage: '',
  showrptfulltext: false,

  breadcrumbsinfo: [],

  pyear: [],
  getreportbyyears: [],

  regfilings: '',
  copymsg: '',
  }
},
methods: {
  //method to format dates. please install moment using npm i moment
  async dateTime(value) {
      return moment(value).format('YYYY-MMMM-DD');
    },
  // async getId(myId, $event){
  //   let id = myId;
  //   let eid = $event.target.id;
  //   var myVueElement = document.getElementById("pitdiv" + id);
  //   let x = document.getElementsByClassName("activeElement");
  //   if(x.length > 0) { x[0].classList.remove("activeElement"); }
  //   myVueElement.classList.add("activeElement")
   

  // await axios.get(`getallreportyears/${id}`).then(
  //   response => {
  //       this.getreportbyyears = response.data        
  // })
  // .catch((error) => {
  //     console.log(error)
  //   })
  // },
  async getIdValue($event){
    let myid = $event.target.value;
    if (myid > 0 ) {
      var myVueElement = document.getElementById("pitdiv" + myid);
    let x = document.getElementsByClassName("activeElement");

      if(x.length > 0) 
        { 
          x[0].classList.remove("activeElement"); 
        }
        myVueElement.classList.add("activeElement")
  
      await axios.get(`getinvestfinyear/${myid}`).then(
        response => {
            this.getreportbyyears = response.data        
      })
      .catch((error) => {
          console.log(error)
        })
    }
    
 

  },
  
},
async mounted() {
  this.myPicUrl = myUrlPath
  

   await axios.get('allpagespv/financialreporting').then(
    response => {
      this.videoimage = response.data
      
      this.imagetext = this.videoimage.pvdisplaytext 
      this.src = this.videoimage.pvsrc
      this.playrate = this.videoimage.playbackrate
      this.poster = this.videoimage.pvposter
      this.pvstyle = this.videoimage.pvstyle
      this.pvisvideo = this.videoimage.pvisvideo
      this.pvpanorama1 = this.videoimage.pvpanorama1
      this.pvpanorama2 = this.videoimage.pvpanorama2
      this.pvpanorama3 = this.videoimage.pvpanorama3
      this.pvhotspot1 = this.videoimage.pvhotspot1
      this.pvhotspot2 = this.videoimage.pvhotspot2
      this.pvhotspot3 = this.videoimage.pvhotspot3
      this.pvpictureimage = this.videoimage.pvpictureimage

       if (this.pvisvideo === true) {
          this.src = this.videoimage.pvsrc
        }
        else {
            const config = {
            autoLoad: true,
            scenchange: true,
            compass: false,
            northOffset: -20.5,
            default: {
                firstScene: "hotspotoffice",
                sceneFadeDuration: 1000,
                autoRotate: -.7,
                setTimeout: 100,
                preview: this.poster
                
            },
            scenes: {
                hotspotoffice: {
                    hfov: 180,
                    pitch: 0,
                    yaw: 0,
                    type: "equirectangular",
                    panorama: this.pvpanorama1,
                },
                anotherhotspot: {
                      hfov: 180,
                      pitch: 0,
                      yaw: 0,
                      type: "equirectangular",
                      panorama: this.pvpanorama2,
                  },
                  lasthotspot: {
                      hfov: 180,
                      pitch: 0,
                      yaw: 0,
                      type: "equirectangular",
                      panorama: this.pvpanorama3,
                  },
                
              }
          };
          pannellum.viewer('panorama', config);
        }
      })
      .catch((error) => {
          console.log(error)
        })

  //------------Get Reports---------------
  await axios.get('reportpresentationlisting/financialreporting').then(
    response => {
      this.reportpresentation = response.data
      var reportcnt = parseInt(response.data[0].rpid)       

      axios.get(`reportpresentationsinglelisting/${reportcnt}`).then(
      response => {
        this.lastrecordsreportpresent = response.data
        this.rppdfpath = response.data.rppdfpath
        this.rptitle = response.data.rptitle
        this.rpdate = response.data.rpdate
        this.rplinkname = response.data.rplinkname
        this.rptfulltext = response.data.rptfulltext
        this.bgimage = response.data.bgimage
        this.rpcoverpageimagepath = response.data.rpcoverpageimagepath
        this.singlereporttitle = response.data.singlereporttitle
        this.rplinkname = response.data.rplinkname
        this.rpdate = response.data.rpdate
        this.showrptfulltext = response.data.showrptfulltext
      
      })
      .catch((error) => {
        console.log(error)
      })
            
    })
  .catch((error) => {
    console.log(error)
  })

  //------------YEARS---------------
  await axios.get('getallyears/').then(
    response => {
        this.pyear = response.data
  })
  .catch((error) => {
      console.log(error)
    })

  //------------YEARS---------------
  await axios.get('getinvestinfo/').then(
    response => {
        this.regfilings = response.data[0].regfilings
        this.copymsg = response.data[0].copymsg
  })
  .catch((error) => {
      console.log(error)
    })

  //------------breadcrumbs mappings info---------------
  await axios.get('getbreadcrumbsinfo/financialreporting').then(
  response => {
      this.breadcrumbsinfo = response.data
    })
    .catch((error) => {
        console.log(error)
        })

}
}
</script>

<style scoped>


.container {
  display: grid;
  height: 100vh;;
  grid-template-columns: 1fr;
  grid-template-rows: .2fr 1.2fr .2fr;
  grid-template-areas: 
  "nav nav nav" 
  "main main main" 
  "footer footer footer";
  grid-gap: 0.2rem;
  font-family: "Inter", sans-serif;
  font-size: 800;
  font-size: 12px;
  color: #234234;
  text-align: center;
}

html { 
  height: 100%;
  margin:0px;
  background: url('../assets/slide-5.jpg') no-repeat center center;
  background-size: cover;
  background-attachment: fixed;
}

main {
  background: white;
  grid-area: main;
  padding-left: 0px;
  padding-right: 0px;
  margin-left: 0px;
  margin-right: 0px;
  border-radius: 0px;
  margin-top:-5px;
}



.rpttitle, .rpttitle1 {
  font-size: 30px;
  font-family:Verdana, Geneva, Tahoma, sans-serif;
  text-align: center;
  padding: 20px;
  font-weight: bolder;
  color: goldenrod;
}


.rplname {
  padding-top: 40px;
  color:rgb(24, 74, 121);
  font-weight: bold;
}
.linkformat {
  text-decoration: none;
  color:rgb(24, 74, 121);
  font-weight: bold;
  font-size: 20px;
}
.linkformat1 {
  list-style-type: none;
}


/*Reccent Documents*/
.recentdocdiv, .passreports {
 padding-bottom: 100px;
 padding-top: 50px;
 
}
.recentdocsec {
  background-color: whitesmoke;
}
.yearspan {
  float: left; 
  width: 120px; 
  color:rgb(152, 165, 172);
  font-size: 30px;
  font-weight: bold;
  cursor: pointer;
  margin-left: 5px;
  margin-top:10px;
}
.yeardiv {
  text-align: center; 
}
.tablediv {
  padding-top: 200px;
  overflow-x: scroll;
  width: 100%;
}

.table {
  margin-top: 100px; 
  width: 100%;
}
.tdlinkcss {
  text-align: left;
  text-decoration: none;
}


.goalspeftitle {
  font-size: 30px;
  font-weight: bold;
  color:rgb(152, 165, 172);
  padding-bottom: 50px;
}
.activeElement {
  background-color: red;
  font-weight:bold;
}
.allreportsformat {
  margin-top: 300px;
}
.videosection {
  margin-top: -60px;
  height: 600px;
  width: 100%;
  background-color: #003;
}

 .overlay {
  opacity: 0.99;
  width: 100%;
  height: 600px;
  background: linear-gradient(to bottom, #003, transparent);
  margin-top: -600px;

}
img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  background-color: #003;
}
/*===================MEDIA SCREENS TAMPLATES===============*/
 /* Extra small devices (phones, 600px and down) */
 @media only screen and (max-width: 600px) {
  .reportdiv {
    padding: 20px;
    margin-top: 100px;
  }
  .yearspan {
    text-align: center;
  }
  .yeardiv {
    padding-left: 30px;
  }
  .tablediv {
    width: 96%;
    overflow-x: scroll;

  }
  .table {
    margin-top: -130px;
  }
  .goalsandperf{
    padding-left: 20px;
    padding-right: 20px;
  }
  .goalspeftitle {
    text-align: center;
  }
  .regfilingcard {
    margin-left: 20px;
    margin-right: 20px;
    margin-top: 30px;
    margin-bottom: 10px;
    padding: 30px;
  }
  .copymsgclass {
    text-align: center;
    margin-left: 20px;
    margin-right: 20px;
    margin-top: 80px;
    margin-bottom: 80px;
  }


 }

 /* Small devices (portrait tablets and large phones, 600px and up) */
 @media only screen and (min-width: 600px) {

  .yearspan {
    padding-left: 20px;
    padding-right: 20px;
    text-align: center;
  }
  .tablediv {
    width: 98%;
    overflow-x: scroll;
    padding-left: 10px;
  }
  .table {
    margin-top: -130px;
  }
  .goalsandperf{
    padding-left: 40px;
    padding-right: 40px;
  }
  .goalspeftitle {
    text-align: center;
  }
  .regfilingcard {
    margin-left: 20px;
    margin-right: 20px;
    margin-top: 30px;
    margin-bottom: 10px;
    padding: 30px;
  }
  .copymsgclass {
    text-align: center;
    margin-left: 20px;
    margin-right: 20px;
    margin-top: 80px;
    margin-bottom: 80px;
  }

 }
 
 /* Medium devices (landscape tablets, 768px and up) */
@media only screen and (min-width: 768px) {

  .yeardiv {
    padding-left: 20px;
    padding-right: 20px;
    text-align: center;
  }
  .tablediv {
    width: 100%;
    overflow-x: scroll;
    margin-top: -120px;
    padding-left: 10px;
  }
  .goalsandperf{
    padding-left: 60px;
    padding-right: 60px;
  }
  .goalspeftitle {
    text-align: center;
  }
  .regfilingcard {
    margin-left: 40px;
    margin-right: 40px;
    margin-top: 60px;
    margin-bottom: 30px;
    padding: 50px;
  }
  .copymsgclass {
    text-align: center;
    margin-left: 40px;
    margin-right: 40px;
    margin-top: 80px;
    margin-bottom: 80px;
  }
  .breadcrumbcss {
    padding-left: 40px;
  }
 }

 /* Large devices (laptops/desktops, 992px and up) */
@media only screen and (min-width: 992px) {
  .middlecol {
    border-left: thin solid;
    border-right: thin solid;
    height: 370px;
  }
  .yeardiv {
    padding-left: 20px;
    padding-right: 20px;
    text-align: center;
  }
  .tablediv {
    width: 100%;
    overflow-x: scroll;
    margin-top: -120px;
    padding-left: 10px;
  }
  .reportdiv {
    padding: 100px;
    margin-top: 100px;
  }
  .imgwidth {
    width: 100%;
    padding-left: 30px;
    padding-right: 30px; 
  }
  .goalsandperf{
    padding-top: 100px;
    padding-bottom: 100px;
  }
 }


 
 /* Extra large devices (large laptops and desktops, 1200px and up) */
@media only screen and (min-width: 1200px) {

  .yeardiv {
    padding-left: 200px;
  }
  .tablediv {
    width: 100%;
    overflow-x: scroll;
    margin-top: -120px;
    padding-left: 10px;
  }
  .reportdiv {
    padding: 100px;
    margin-top: 100px;
  }
  .recentdocsec {
    padding: 100px;
  }
  .regfilingcard {
    margin-left: 200px;
    margin-right: 200px;
    margin-top: 100px;
    margin-bottom: 100px;
    padding: 50px;
  }
  .copymsgclass {
    text-align: center;
    margin-left: 200px;
    margin-right: 200px;
  }
  .breadcrumbcss {
    padding-left: 200px;
  }

 } 

/* Extra large devices (large laptops and desktops, 1200px and up) */
@media only screen and (min-width: 1400px) {

  .yeardiv {
    padding-left: 130px;
  }
  .tablediv {
    width: 93%;
    overflow-x: scroll;

  }
  .table {
    margin-top: -130px;
  }
  .goalsandperf{
    padding-left: 200px;
    padding-right: 200px;
  }


}

  
@media only screen and (min-width: 1600px) {

  } 
</style>
